import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import rolesEnum from "@/constant/rolesEnum";

const useRoles = () => {
  // @ts-ignore
  const role = useSelector(state => state.profile.profile?.role);
  
  return useMemo(() => {
    const isAdmin = role === rolesEnum.admin;
    const isJuniorAdmin = role === rolesEnum.juniorAdmin;
    const isAdminPanel = role === rolesEnum.adminPanel;
    const isChildren = role === rolesEnum.children;
    const isParent = role === rolesEnum.parent;
    const isHrManager = role === rolesEnum.hrManager;
    const isHtPanel = role === rolesEnum.htPanel;
    const isPersonalManager = role === rolesEnum.personalManager;
    const isSeminarian = role === rolesEnum.seminarian;
    const isSeniorSeminarian = role === rolesEnum.seniorSeminarian;
    const isAdminOrJuniorAdmin = isAdmin || isJuniorAdmin;
    const isChildrenOrParent = isChildren || isParent;

    return {
      isAdmin,
      isJuniorAdmin,
      isAdminPanel,
      isChildren,
      isParent,
      isHrManager,
      isHtPanel,
      isPersonalManager,
      isSeminarian,
      isSeniorSeminarian,
      isAdminOrJuniorAdmin,
      isChildrenOrParent
    };
  }, [role]);
};

export default useRoles;